import {
  TaskQueryStatusEnum,
  TaskStatusEnum,
  TranslationRequestStatusEnum,
  TranslationRequestStatusFilterEnum
} from 'gql/graphql';
import {
  CorrectingIcon,
  FinishedIcon,
  InProgressIcon,
  PostponedIcon,
  QuotedIcon,
  ReadyForReviewIcon,
  UntranslatedIcon,
  WaitingTranslatorIcon
} from 'lib/svgs/Icons';

export type ColorsStatus = 'green' | 'gray' | 'grayDark' | 'blue' | 'cyan' | 'yellow' | 'red';

export type ThemeStatus = { icon: JSX.Element; color: ColorsStatus };

export const THEME_TASK_STATUS: Record<TaskStatusEnum, ThemeStatus> = {
  [TaskStatusEnum.Adjourned]: {
    icon: PostponedIcon(),
    color: 'gray'
  },
  [TaskStatusEnum.Buffering]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.ClientReview]: {
    icon: ReadyForReviewIcon(),
    color: 'cyan'
  },
  [TaskStatusEnum.Confirmed]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.Correcting]: {
    icon: CorrectingIcon(),
    color: 'yellow'
  },
  [TaskStatusEnum.Finished]: {
    icon: FinishedIcon(),
    color: 'green'
  },
  [TaskStatusEnum.Initialized]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.Paused]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.Proofreading]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TaskStatusEnum.Rerouted]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.Rerouting]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskStatusEnum.TaskTranslating]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TaskStatusEnum.WaitingForMachineTranslations]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  }
};

export const THEME_TASK_QUERY_STATUS: Record<TaskQueryStatusEnum, ThemeStatus> = {
  [TaskQueryStatusEnum.Adjourned]: {
    icon: PostponedIcon(),
    color: 'gray'
  },
  [TaskQueryStatusEnum.Initialized]: {
    icon: WaitingTranslatorIcon(),
    color: 'grayDark'
  },
  [TaskQueryStatusEnum.Active]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TaskQueryStatusEnum.ClientReview]: {
    icon: ReadyForReviewIcon(),
    color: 'cyan'
  },
  [TaskQueryStatusEnum.Correcting]: {
    icon: CorrectingIcon(),
    color: 'yellow'
  }
};

export const THEME_TRANSLATION_REQUEST_STATUS: Record<TranslationRequestStatusEnum, ThemeStatus> = {
  [TranslationRequestStatusEnum.Adjourned]: {
    icon: PostponedIcon(),
    color: 'gray'
  },
  [TranslationRequestStatusEnum.Canceled]: {
    icon: UntranslatedIcon(),
    color: 'red'
  },
  [TranslationRequestStatusEnum.Finished]: {
    icon: FinishedIcon(),
    color: 'green'
  },
  [TranslationRequestStatusEnum.InTranslation]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TranslationRequestStatusEnum.PaymentFailed]: {
    icon: UntranslatedIcon(),
    color: 'red'
  },
  [TranslationRequestStatusEnum.Pending]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TranslationRequestStatusEnum.Unordered]: {
    icon: QuotedIcon(),
    color: 'gray'
  },
  [TranslationRequestStatusEnum.WaitingForClient]: {
    icon: ReadyForReviewIcon(),
    color: 'cyan'
  }
};

export const THEME_TRANSLATION_REQUEST_STATUS_FILTER: Record<
  TranslationRequestStatusFilterEnum,
  ThemeStatus
> = {
  [TranslationRequestStatusFilterEnum.Unordered]: {
    icon: QuotedIcon(),
    color: 'gray'
  },
  [TranslationRequestStatusFilterEnum.InProgress]: {
    icon: InProgressIcon(),
    color: 'blue'
  },
  [TranslationRequestStatusFilterEnum.ReadyToReview]: {
    icon: ReadyForReviewIcon(),
    color: 'cyan'
  },
  [TranslationRequestStatusFilterEnum.Finished]: {
    icon: FinishedIcon(),
    color: 'green'
  },
  [TranslationRequestStatusFilterEnum.Adjourned]: {
    icon: PostponedIcon(),
    color: 'gray'
  },
  [TranslationRequestStatusFilterEnum.Failed]: {
    icon: UntranslatedIcon(),
    color: 'red'
  }
};
